/**
 * Returns a monotonic timestamp in milliseconds when the Performance API is available.
 * @returns Current monotonic timestamp in milliseconds, or 0 when unavailable.
 */
export function monotonicNowMs(): number {
  return typeof performance !== 'undefined' ? performance.now() : 0;
}

/**
 * Isolates analytics and operational telemetry callbacks so transport errors
 * never disrupt the observed user or background flow.
 * @param report - Callback performing telemetry work.
 */
export function reportSafely(report: () => void): void {
  try {
    report();
  } catch (error) {
    // Telemetry failures must preserve the operation being observed.
    console.error('Glyph Map analytics failed', error);
  }
}
